export const CONNECTION_STATUS = {
  ONLINE: "online",
  OFFLINE: "offline",
  RECOVERING: "recovering",
  RECOVERED: "recovered",
} as const;
